<template>
    <div class="searchbox-container">
      <i class="fas fa-search"></i>
      <input class="searchbox" :class="{showSuggested :suggestedCountries.length}"
          type="text" 
          :placeholder="placeholder"
          v-model="searchQuery"
          @input="updateQuery"
          >
      <ul class="suggestion-container" v-if="suggestedCountries.length">
        <li v-for="(country, index) in suggestedCountries" :key="index + 1">
          <router-link class="suggestion-item" :to="{ name: 'Country', params: {country: country.name}}">
            <img class="suggestion-img" :src="country.flag">
            <p>{{ country.name }}</p>
          </router-link>
        </li>
      </ul>
    </div>
    
</template>

<script>
export default {
    props: {
        placeholder: String,
    },
    data() {
        return {
            suggestedCountries: {},
            searchQuery: null
        }
    },
    methods: {
        updateQuery() {
            if(this.searchQuery.length >= 3) {
                fetch(`https://restcountries.eu/rest/v2/name/${this.searchQuery}`)
                    .then(res => res.json())
                    .then(data => this.suggestedCountries = data)
                    .catch(err => console.log(err))
            } else {
                this.suggestedCountries = {}
            }
            console.log(this.suggestedCountries)
        }
    }
}
</script>

<style lang="scss">
.searchbox-container { position: relative }

.fa-search { 
  position: absolute;
  font-size: 1.25rem;
  color: hsl(0, 0%, 81%);
  top: 50%;
  transform: translate(70% ,-50%);
  @media (min-width: 46.88em) {
      transform: translate(70% ,-160%);
  }
}

.searchbox {
  display: block;
  width: 100%;
  max-width: 30.13rem;
  box-sizing: border-box;
  font-family: inherit;
  font-size: .875rem;
  padding: 1rem 1rem 1rem 3rem;
  border-radius: 5px;
  border: none;
  box-shadow: 0 2px 6px rgba($color: #000000, $alpha: .07);
  @media (min-width: 46.88em) {
    width: 30.13rem;
    
  }

  
  &::placeholder { color: hsl(0, 0%, 52%) }
  &:focus {
    border: none;
    outline: none;
  }
}

      
.suggestion-container {
  transform: translateY(5%);
  position: absolute;
  z-index: 10;
  width: 100%;
  margin: 0 auto;
  padding: 1rem 1.875rem;
  background-color: hsl(0, 0%, 100%);
  border-radius: .25rem;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
  
  li {
    list-style: none;
    padding: .875rem 0;

    .suggestion-item {
      text-decoration: none;
      color: inherit;
      text-align: center;
      display: flex;
      @media (min-width: 48em) {
        cursor: pointer;
      }
    }
  }

  img {
    height: 1.25rem;
    margin-right: .75rem;
  }
}
    
  

</style>